
import { Router } from '@angular/router';
import {  OidcSecurityService } from 'angular-auth-oidc-client';
import { IApplicationDirector, Dependencies as CoreDependencies } from '@portable/core/director';
import { ApplicationDirector as CoreDirector } from '@portable/core/director';
import { UserProfile } from 'src/shared/models/user-profile.model';
import { ProfileService } from 'src/shared/services/profile.service';
import { AccountService } from 'src/shared/services/account.service';
import { PlatformService } from 'src/shared/services/platform.service';
import { ConfigService } from 'src/shared/services/config.service';
import { UserService } from 'src/app/services/user/user.service';
import { Channels } from './channels';

const locations = {
    '404': '/...',
    'UNAUTHENTICATED': '/unauthorized',
    'UNAUTHORIZED': '/unauthorized',
    'LOGIN': '/login',
    'LOGOUT': '/logout',
    'INACTIVE': '/inactive',
    'HOME': '/home',
    'CONTACT': '/contact',
};

interface Dependencies extends CoreDependencies {
    router: Router;
    user: UserService;
    profile: ProfileService;
    account: AccountService;
    platform: PlatformService;
    config: ConfigService;
}


class ApplicationDirector extends CoreDirector implements IApplicationDirector {
    private _token: any = '';  // temp
    private _isRedirect: boolean = false;
    // SERVICES BEGIN
    public $router: Router;
    public $user: UserService;
    public $profile: ProfileService;
    public $platform: PlatformService;
    public $config: ConfigService;
    // SERVICES END
    public locations: any = locations;
    public override events: Channels = new Channels();

    constructor(public _oidcSecurityService: OidcSecurityService,
        public _configService: ConfigService) {
        super();
        var publishers = {
            [this.events['AUTHENTICATION:USER']]: this.handleUser,
        };

        this.register('publishers', publishers);
    }

    override init(o: Dependencies) {
        var { router,  user: $user,  profile,  platform, config } = o;

        super.init(o);
        this.$router = router;
        this.$user = $user;
        this.$profile = profile;
        this.$platform = platform;
        this.$config = config;
      
        return this;
    }

    protected override handleUser(channel: string, userProfile: UserProfile) {
        this.getDefaultPath();
        let user = new UserProfile(userProfile);  
        super.handleUser(channel, user);
        this.$platform.announceUserProfile(user);  // TODO: Remove; use only be for backward-compatibility
    }

    private getDefaultPath() {
        let path = localStorage.getItem("redirectTo");
        if (path) {
            this._isRedirect = true;
            localStorage.removeItem("redirectTo");
            if (path === "changepassword") {
                path = "/profile?tab=password";
                this.$router.navigateByUrl(path);
            }           
        }
    }
}

export { ApplicationDirector as Director };
